import { fetchRetryWrapper } from "./fetch-retry-wrapper.js";

export const api = async (params) => {
  const { path, method, body, config, fetchRetry, stopRedirect } = params;

  let url = `${process.env.API_URL}/v1/${path}`;
  let data = {
    method: method,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  if (body) {
    data.body = JSON.stringify({
      ...body,
    });
  }

  let response;
  try {
    response = fetchRetry
      ? fetchRetryWrapper(url, data)
      : await fetch(url, data);

    if (!response.ok) {
      if (response?.status === 401 && !stopRedirect) {
        console.log("REDIRECT lo login page");
        localStorage.clear();
        // store the path and after login -> redirect to that path
        localStorage.setItem("page-after-login", window.location.pathname);
        window.location.replace(`/auth.html?v=${new Date().getTime()}`);
      }
      throw new Error(`Error: ${response?.status} ${response?.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.log("Error in API:", error, response);
    if (response) {
      const errorResponse = await response.json();
      throw new Error(
        `Error: ${response?.status} ${response?.statusText}; Message: ${errorResponse?.message}`
      );
    } else throw error;
  }
};
